export default __webpack_public_path__ + "static/media/fridge1-after1-2048w.2d109965.png";